import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Selectors
import {
  selectCustomerPhotoUri,
  selectStickyBrandingFirstName,
  selectStickyBrandingFullName,
} from 'src/store/selectors/customerProfile'

// Components
import { Avatar, Text } from 'src/Components'

// Styles
import styles from './StickyBrandingHeader.module.scss'

export const StickyBrandingHeader = () => {
  const customerPhoto = useSelector(selectCustomerPhotoUri)
  const customerFullName = useSelector(selectStickyBrandingFullName)
  const customerFirstName = useSelector(selectStickyBrandingFirstName)

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Avatar className={styles.avatar} src={customerPhoto} />
      </div>
      <div className={styles.short}>
        <Text
          element='span'
          weight='semibold'
          variant='neutralCool'
          variantCount='900'
        >
          {customerFirstName}
        </Text>
      </div>
      <div className={styles.long}>
        <Text
          element='span'
          variant='neutralCool'
          weight='bold'
          size='tiny'
          transform='uppercase'
          variantCount='700'
        >
          {customerFullName && (
            <FormattedMessage
              id='StickyBranding.lendingBro'
              defaultMessage='Lending Pro'
            />
          )}
        </Text>
        <Text
          element='span'
          size='s'
          weight='semibold'
          variant='neutralCool'
          variantCount='900'
        >
          {customerFullName}
        </Text>
      </div>
    </div>
  )
}
